// extracted by mini-css-extract-plugin
module.exports = {"CardWrap":"CardWrap--8Acob","bankName":"bankName--uWWeO","bankNameTip":"bankNameTip--Cu-wz","bankNo":"bankNo--PBYKm"};